'use client';

import { useSidebar } from '@/components/elements/Sidebar/sidebar-provider';

function MobileMenu() {
  const { isCollapsed, setIsCollapsed } = useSidebar();

  return (
    <button
      aria-label="Toggle menu"
      onClick={() => setIsCollapsed((o) => !o)}
      className="relative flex h-6 w-6 flex-col items-center justify-center md:hidden"
    >
      <div className="flex h-6 w-6 flex-col justify-between">
        <div
          className={`h-0.5 w-full bg-white transition-all duration-300 ${
            !isCollapsed ? 'opacity-0' : 'opacity-100'
          } `}
        />
        <div
          className={`h-0.5 w-full bg-white transition-transform duration-300 ${
            !isCollapsed ? 'translate-y-0.5 rotate-45 transform' : 'rotate-0 transform'
          } `}
        />
        <div
          className={`h-0.5 w-full bg-white transition-transform duration-300 ${
            !isCollapsed ? '-translate-y-2.5 -rotate-45 transform' : 'rotate-0 transform'
          } `}
        />
      </div>
    </button>
  );
}

export default MobileMenu;
